import { withTranslation } from '@application/i18n/with_translation';
import { ButtonArrange, Flex, Form } from '@cellula/react';
import { TopBar } from '@component/top_bar.component';
import { DynamicForm } from '@feature/dynamic_form/dynamic_form.component';
import { useEffect } from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router';
import { useScreenForms } from './use_forms';

export function ScreenForms(): JSX.Element | null {
	const screenForms = useScreenForms();

	return (
		<>
			<TopBar.Content goBack />
			{screenForms.forms.status === 'accessible' && screenForms.forms.value ? (
				<Routes>
					<Route
						path=':formId/:formPage?'
						element={<SingleForm loadSingleForm={screenForms.loadSingleForm} formWorker={screenForms.formWorker} />}
					/>
					<Route path='*' element={<Navigate to={`./${screenForms.forms.value[0]?.Id}`} replace />} />
				</Routes>
			) : null}
		</>
	);
}

interface SingleFormProps {
	loadSingleForm(formId: number): Promise<void>;
	formWorker: { value: Readonly<import('@feature/dynamic_form/form_manager/form_worker').FormWorker> | null; status: string };
}

function SingleForm({ loadSingleForm, formWorker }: SingleFormProps) {
	const params = useParams();
	const formPage = params.formPage ?? 0;

	useEffect(
		function whenMount() {
			loadSingleForm(Number(params.formId));
		},
		[loadSingleForm, params.formId],
	);

	if (formWorker.status !== 'accessible' || !formWorker.value) {
		if (formWorker.status === 'error') return <div>Error...</div>;
		return <div>Loading...</div>;
	}

	return (
		<DynamicForm.Root formWorker={formWorker.value} defaultPagePosition={Number(formPage)}>
			<DynamicForm.Description />
			<DynamicForm.Content>
				<Flex grow={1} justify='flex-end'>
					<ButtonArrange>
						<Form.SubmitButton>{withTranslation('PW.Common.Next')}</Form.SubmitButton>
					</ButtonArrange>
				</Flex>
			</DynamicForm.Content>
		</DynamicForm.Root>
	);
}
